import { useMemo } from 'react';

import { BROWSER_DEFAULT_FONT_SIZE } from '../constants';

import style from '../AdvancedPlayerMessage.scss';

export const pxToEm = px => px / BROWSER_DEFAULT_FONT_SIZE;

export const sizeInEm = ({ width = 0, height = 0 }) => ({
    width: `${pxToEm(width)}em`,
    height: `${pxToEm(height)}em`
});

export const useStyleAttributes = ({ imageInfo, imageUrl }) => useMemo(() => {
    let className = style.popup;
    let inlineStyle = {};

    if (imageInfo) {
        const { width, height } = sizeInEm(imageInfo);

        if (imageInfo.error) {
            className += ` ${style.noImage}`;
        } else {
            inlineStyle = {
                width,
                height,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: `${width} ${height}`
            };
        }
    }

    return {
        className,
        inlineStyle
    };
}, [imageInfo, imageUrl]);
